import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES_CONFIG, ModuleType } from '@contracts';
import { DialogService, I18nService } from '@core';
import { AuthModule } from '@feature/auth';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [AuthModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
})
export class LoginPageComponent {
  private app = inject(APP_ROUTES_CONFIG);
  private i18n = inject(I18nService);

  constructor(
    private readonly router: Router,
    private readonly dialogService: DialogService,
  ) {}

  handleLoginSuccess = (module: ModuleType) => {
    this.i18n.init();
    this.router.navigateByUrl(this.app.defaultRoutes[module]);
  };

  handleLoginError = () => {
    this.dialogService.error('เข้าสู่ระบบไม่สำเร็จ');
  };

  handleResetError = () => {
    this.dialogService.error('เปลี่ยนรหัสผ่านไม่สำเร็จ');
  };
}
